module.exports = __webpack_public_path__ + "static/media/Logo Vector Blanco.27b25c18.png";